/**
 * セッション無効マーカーによる 401 の識別子。
 * サーバ側は AdminSessionDestroyedMarkerFacade::REJECTED_EXCEPTION でこの値を返す。
 */
export const SESSION_DESTROYED_EXCEPTION = 'session_destroyed';

/**
 * 破棄済みの職員セッションで操作が続いていることによる 401 かを判定する。
 *
 * この 401 を受け取った時点でサーバ側はセッションを破棄済みなので、画面をそのまま使い続けても
 * 以降のリクエストはすべて失敗する。呼び出し側のエラーハンドリングに依らずログイン画面へ戻すため、
 * 各 HTTP クライアントの interceptor から使う。
 *
 * @param status レスポンスのHTTPステータス
 * @param exception レスポンスボディの error.exception
 */
export const isSessionDestroyedError = (status: number | undefined, exception: unknown): boolean =>
  status === 401 && exception === SESSION_DESTROYED_EXCEPTION;
